import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { DIVISIONS, STATUSES, CONDITIONS } from "../../lib/api";

const Text = ({ label, value, onChange, placeholder, testid, type = "text" }) => {
  const [v, setV] = useState(value || "");
  useEffect(() => {
    setV(value || "");
  }, [value]);
  useEffect(() => {
    if ((value || "") === v) return undefined;
    const t = setTimeout(() => onChange(v), 400);
    return () => clearTimeout(t);
  }, [v]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div>
      {label && <label className="label">{label}</label>}
      <input type={type} className="field !py-2.5" value={v} placeholder={placeholder} onChange={(e) => setV(e.target.value)} data-testid={testid} />
    </div>
  );
};

const Select = ({ label, value, onChange, options, testid, any = "Any" }) => (
  <div>
    <label className="label">{label}</label>
    <select className="field !py-2.5" value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={testid}>
      <option value="">{any}</option>
      {options.map((o) => (Array.isArray(o) ? <option key={o[0]} value={o[0]}>{o[1]}</option> : <option key={o} value={o}>{o}</option>))}
    </select>
  </div>
);

export const FilterPanel = ({ params, set, clear, facets, fixedDivision }) => {
  const division = fixedDivision || DIVISIONS.find((d) => d.key === params.get("division"));
  const categories = division ? division.categories : DIVISIONS.flatMap((d) => d.categories);
  const conditions = Array.from(new Set([...CONDITIONS, ...(facets?.conditions || [])]));
  const g = (k) => params.get(k) || "";

  return (
    <div className="space-y-6" data-testid="inventory-filters">
      <div className="flex items-center justify-between">
        <p className="eyebrow">Refine</p>
        <button onClick={clear} className="text-xs text-slate-300 hover:text-gold flex items-center gap-1" data-testid="filters-clear-button"><X className="w-3 h-3" /> Clear all</button>
      </div>
      {!fixedDivision && <Select label="Division" value={g("division")} any="All divisions" onChange={(v) => set({ division: v, category: "" })} options={DIVISIONS.map((d) => [d.key, d.name])} testid="filter-division-select" />}
      <Select label="Asset type" value={g("category")} onChange={(v) => set({ category: v })} options={categories} testid="filter-category-select" />
      <Text label="Make" value={g("make")} onChange={(v) => set({ make: v })} placeholder={facets?.makes?.slice(0, 2).join(", ") || "e.g. Peterbilt"} testid="filter-make-input" />
      <Text label="Model" value={g("model")} onChange={(v) => set({ model: v })} placeholder="e.g. 579" testid="filter-model-input" />
      <div>
        <label className="label">Price (USD)</label>
        <div className="grid grid-cols-2 gap-2">
          <Text type="number" value={g("min_price")} onChange={(v) => set({ min_price: v })} placeholder="Min" testid="filter-min-price-input" />
          <Text type="number" value={g("max_price")} onChange={(v) => set({ max_price: v })} placeholder="Max" testid="filter-max-price-input" />
        </div>
      </div>
      <div>
        <label className="label">Year</label>
        <div className="grid grid-cols-2 gap-2">
          <Text type="number" value={g("min_year")} onChange={(v) => set({ min_year: v })} placeholder="From" testid="filter-min-year-input" />
          <Text type="number" value={g("max_year")} onChange={(v) => set({ max_year: v })} placeholder="To" testid="filter-max-year-input" />
        </div>
      </div>
      <Select label="Condition" value={g("condition")} onChange={(v) => set({ condition: v })} options={conditions} testid="filter-condition-select" />
      {facets?.locations?.length ? (
        <Select label="Location" value={g("location")} onChange={(v) => set({ location: v })} options={facets.locations} testid="filter-location-select" />
      ) : (
        <Text label="Location" value={g("location")} onChange={(v) => set({ location: v })} placeholder="City or state" testid="filter-location-input" />
      )}
      <Select label="Availability" value={g("status")} onChange={(v) => set({ status: v })}
        options={Object.entries(STATUSES).filter(([k]) => k !== "sold").map(([k, s]) => [k, s.label])} testid="filter-status-select" />
    </div>
  );
};
